module.exports = __webpack_public_path__ + "img/aplicaciones-foto1.09420c6e.png";